import styled from 'styled-components'

const Container = styled.input`
  flex: 0;
  padding: 0.3rem;
  border: 2px solid lightgrey;
`

export default function NoteTitle({ editing, value, onChange, ...rest }) {

  const changeHandler = (e) => {
    if (editing) {
      onChange(e.target.value);
    }
  }

  return (
    <Container
      type="text"
      value={value}
      onChange={changeHandler}
      {...rest}
    >
    </Container>
  );
}
